module.exports = __webpack_public_path__ + "img/google-maps-marker-red.b69f0297.png";